var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import posthog from 'posthog-js';
var PostHogSessionRecorder = /** @class */ (function () {
    function PostHogSessionRecorder(inDev, apiKey, apiHost) {
        if (apiHost === void 0) { apiHost = 'https://eu.i.posthog.com'; }
        this.inDev = inDev;
        this.apiKey = apiKey;
        this.apiHost = apiHost;
        // Initialize PostHog
        posthog.init(this.apiKey, {
            api_host: this.apiHost,
            autocapture: true, // Enable automatic event capture
            disable_session_recording: true, // Disable session recording by default
        });
        this.log('PostHog initialized');
    }
    /**
     * Start session recording and optionally set metadata
     * @param metadata - Optional metadata to associate with the session
     */
    PostHogSessionRecorder.prototype.startRecording = function (metadata) {
        if (metadata) {
            // Set user properties (metadata) if provided
            var userId = metadata.userId, properties = __rest(metadata, ["userId"]);
            if (userId) {
                posthog.identify(userId, properties);
            }
            else {
                posthog.register(properties); // Register properties without a userId
            }
            this.log('Session recording started with metadata:', metadata);
        }
        else {
            this.log('Session recording started without metadata');
        }
        // Start session recording
        posthog.startSessionRecording();
    };
    /**
     * Stop session recording
     */
    PostHogSessionRecorder.prototype.stopRecording = function () {
        posthog.stopSessionRecording();
        this.log('Session recording stopped');
    };
    /**
     * Log messages to the console only in development mode
     * @param args - Arguments to log
     */
    PostHogSessionRecorder.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.inDev) {
            console.log.apply(console, args);
        }
    };
    return PostHogSessionRecorder;
}());
export default PostHogSessionRecorder;
export var trackSeyel = function (module, event, properties) {
    window.logSeyel(module, event, properties);
};
